export const CLASS_KEYS = Object.freeze([
    "Root",
    "Object",
    "Field",
    "Array",
    "Value",
    "Reference"
]);
